import emberConfig from 'ember-get-config';

export const getCurrentProtocol = () => {
  return typeof window !== 'undefined' ? window.location.protocol : 'https:';
};

export const getMessagingApiUrl = (getProtocol = getCurrentProtocol) => {
  if (emberConfig.messagingApiUrl) {
    return emberConfig.messagingApiUrl;
  }

  const host = emberConfig.messagingApiHost;

  if (emberConfig.environment === 'development') {
    const protocol = getProtocol();
    return `${protocol}//${host}`;
  }

  return `https://${host}`;
};

export default () => getMessagingApiUrl();
